import { staffCreatedRequestSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffRequestCreateApi(options) {
    const send = createMemoryTransport(options);
    return {
        createForCustomer: (customerId, body, commandOptions) => send({
            method: "POST",
            path: `/staff/customers/${encodeURIComponent(customerId)}/concierge-requests`,
            body,
            schema: staffCreatedRequestSchema,
            idempotencyKey: commandOptions?.idempotencyKey,
            signal: commandOptions?.signal,
        }),
    };
}
